export const TEXT_INPUT_TYPES = {
  EMAIL: 'email',
  PASSWORD: 'password',
  SEARCH: 'search',
  TEXT: 'text',
  URL: 'url',
  NUMBER: 'number',
} as const;

export const LEFT_PADDING = 10;
export const RIGHT_PADDING = 16;
export const ICON_SIZE = 20;
